import React from "react";
import { Icon, Stack, Text } from "@bookingcom/bui-react";
import { CheckmarkFillIcon, CrossIcon } from "@bookingcom/bui-assets-react/streamline";
import { useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
export function SirfEligibilityMessage({ status }) {
    const i18n = useI18n();
    switch (status) {
        case "SPANISH_RESIDENT_FARE":
            return (React.createElement(Stack, { direction: "row", alignItems: "center", grow: true, gap: 2 },
                React.createElement(Icon, { svg: CheckmarkFillIcon, size: "small", color: "constructive", "aria-hidden": "true" }),
                React.createElement(Text, { variant: "body_2", color: "constructive" }, i18n.trans(t("flights_fd_sirf_eligible")))));
        case "NO_SIRF_SUBSIDY":
            return (React.createElement(Stack, { direction: "row", alignItems: "center", grow: true, gap: 2 },
                React.createElement(Icon, { svg: CrossIcon, size: "small", "aria-hidden": "true" }),
                React.createElement(Text, { variant: "body_2", color: "neutral" }, i18n.trans(t("flights_fd_sirf_not_eligible")))));
        default:
            return undefined;
    }
}
